import { apiRequest } from "../_core/apiRequest";
import { unwrapProfileResponse } from "./profileResponseEnvelope";

export async function updateProfileInfo(infoData) {
  const response = await apiRequest({
    method: "put",
    path: "/profile/info",
    data: infoData,
    errorMessage: "Erro ao atualizar perfil",
  });

  return unwrapProfileResponse(response);
}
